/// <reference path="../../../../../typings/index.d.ts" />

/*
    Directive for additional functionality of typeAhead
    If we delete a value in typeAhead manually, it will revert it to last one or slowly update a model
*/

module Meevo.Plugins.ActivityLog {
    export class ActivityLogApplyOnDelete implements angular.IDirective {
        restrict = 'A';
        link = (scope: any, element: any) => {
            let input = $(element).find('.meevo-typeahead-input');
            let childScope = $(element).children().scope();

            input.on('blur', () => {
                this.$timeout(() => {
                    childScope.$apply();
                }, 100);
            })
        };

        constructor(
            protected $timeout
        ) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => new ActivityLogApplyOnDelete($timeout);
            directive.$inject = [
                '$timeout'
            ];

            return directive;
        }
    }

    angular.module('meevo.plugins.activityLog')
        .directive('activityLogApplyOnDelete', ActivityLogApplyOnDelete.factory());
}